import Layout from "../components/Layout";
import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import { BASE_URL } from "../utils/commonUrl";
import { useSelector } from "react-redux";
import { Fragment } from "react";
import { Toast } from "primereact/toast";
import EmpInfoCard from "../components/EmpInfoCard";
import Moment from "moment";


import { Modal, Button } from "react-bootstrap";
import CardHeader from "react-bootstrap/esm/CardHeader";

const TaskListReport = () => {
    const { user } = useSelector(state => state['auth']);
    const [quater, setQuater] = useState([]);
    const [tableData, setTableData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    //const [taskList, setTaskList] = useState([]);
    const [taskListTableData, setTaskListTableData] = useState([]);
    const [activityList, setActivityList] = useState([]);
    const [doFirstData, setDoFirst] = useState([]);
    const [scheduleData, setSchedule] = useState([]);
    const [delegateData, setDelegate] = useState([]);
    const [doNotDoData, setDoNotDo] = useState([]);

    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    // const handleShow = () => setShow(true);

    const [employeeCode, setEmployeeCode] = useState([]);
    const [employeeName, setEmployeeName] = useState([]);
    const [department, setDepartment] = useState([]);
    const [designation, setDesignation] = useState([]);

    useEffect(() => {
        loadAllEmployees(user.registerID);
        getQuarterActiveList();
    }, [doFirstData]);

    const loadAllEmployees = () => {
        axios.get(BASE_URL + "/api/employeetasklist/GetAllEmployeeListForReport/" + user.registerID)
            .then(response => {
                setTableData(response.data)
                //console.log(response.data);
            })
            .catch(e => {
                console.log(e)
            })
    };

    const getQuarterActiveList = () => {
        axios.get(BASE_URL + "/api/quarter/GetActiveList")
            .then(response => {
                setQuater(response.data)
            })
            .catch(e => {
                console.log(e)
            })
    }

    const onReportPreview = async (registerId, employeeCode, employeeName, department, designation) => {
        getTaskList(registerId, user.quarterID);
        getPlotWiseTaskList();
        getActivityList(registerId, user.quarterID);
        setEmployeeCode(employeeCode);
        setEmployeeName(employeeName);
        setDepartment(department);
        setDesignation(designation);
        //ViewModal();
        //setShow(true);        
    }

    const onPdfReportPreview = async (registerId) => {
        window.open("http://localhost:13805/PMSReport/GetEmployeeWiseTaskListReport?SearchStr="+btoa("RegisterID=" + registerId+"&QuarterID=" + user.quarterID));    
        //window.open("https://apps.bitopibd.com/BIMOBApps/PMSReport/IndividualPerformanceReport?SearchStr="+btoa("RegisterID=" + empIdp.registerID+"&QuarterID=" + user.quarterID));          
    }

    const getTaskList = async (id, quarterID) => {
        const data = {
            RegisterID: id,
            QuarterID: parseInt(quarterID)
        }
        setIsLoading(true);
        await axios.post(BASE_URL + "/api/employeetasklist/GetEmployeeTaskList", JSON.stringify(data))
            .then(response => {
                setTaskListTableData(response.data);
                //console.log(taskListTableData);
                getPlotWiseTaskList(response.data);
                setIsLoading(false);
            })
            .catch(function (error) {
                setTaskListTableData(false);
                console.log(error);
            });
    };

    const getPlotWiseTaskList = async (data) => {
        setDoFirst(data.filter((item) => Number(item.supervisorComment) === 1));
        //ViewModal(doFirstDataVar);
        setSchedule(data.filter((item) => Number(item.supervisorComment) === 2));
        setDelegate(data.filter((item) => Number(item.supervisorComment) === 3));
        setDoNotDo(data.filter((item) => Number(item.supervisorComment) === 4));
    };

    const getActivityList = async (id, quarterID) => {
        const data = {
            RegisterID: id,
            QuarterID: parseInt(quarterID)
        }
        setIsLoading(true);
        await axios.post(BASE_URL + "/api/employeetasklist/GetEmployeeActivity", JSON.stringify(data))
            .then(response => {
                setActivityList(response.data);
                setIsLoading(false);
                console.log(response.data);
            })
            .catch(function (error) {
                setActivityList(false);
                console.log(error);
            });
    }

    function Table({ tableData }) {
        return (
            <table className="table" >
                <thead>
                    <tr>
                        <th>SL.</th>
                        <th>Employee Code</th>
                        <th>Employee Name</th>
                        <th>Department</th>
                        <th>Designation</th>
                        <th className="text-center">Action</th>
                        <th className="text-center">Action</th>
                    </tr>
                </thead>
                <tbody>
                    {tableData.map((data, index) => {
                        return (
                            <tr key={index}>
                                <td>{index + 1}</td>
                                <td>{data.employeeCode}</td>
                                <td>{data.employeeName}</td>
                                <td>{data.department}</td>
                                <td>{data.designation}</td>
                                <td className="text-center">
                                    <input
                                        type="submit"
                                        onClick={() => onReportPreview(data.registerID, data.employeeCode, data.employeeName, data.department, data.designation)}
                                        //onClick={handleShow}
                                        className="btn btn-danger"
                                        value="View" />
                                </td>
                                <td className="text-center">
                                    <input
                                        type="submit"
                                        onClick={() => onPdfReportPreview(data.registerID)}
                                        //onClick={handleShow}
                                        className="btn btn-danger"
                                        value="Report" />
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        );
    }

    function TaskListTable({ taskListTableData }) {
        return (
            <table className="table" >
                <thead>
                    <tr>
                        <th>SL.</th>
                        <th>Task</th>
                    </tr>
                </thead>
                <tbody>
                    {taskListTableData.map((data, index) => {
                        return (
                            <tr key={index}>
                                <td>{index + 1}</td>
                                <td>{data.activity}</td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        );
    }


    function DoFirstTable({ doFirstData }) {
        return (
            <table className="table text-bg-info" >
                <thead>
                    <tr>
                        <th>SL.</th>
                        <th>Task</th>
                    </tr>
                </thead>
                <tbody>
                    {doFirstData.map((data, index) => {
                        return (
                            <tr key={index}>
                                <td>{index + 1}</td>
                                <td>{data.activity}</td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        );
    }

    function ScheduleTable({ scheduleData }) {
        return (
            <table className="table text-bg-info" >
                <thead>
                    <tr>
                        <th>SL.</th>
                        <th>Task</th>
                    </tr>
                </thead>
                <tbody>
                    {scheduleData.map((data, index) => {
                        return (
                            <tr key={index}>
                                <td>{index + 1}</td>
                                <td>{data.activity}</td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        );
    }

    function DelegateTable({ delegateData }) {
        return (
            <table className="table text-bg-info" >
                <thead>
                    <tr>
                        <th>SL.</th>
                        <th>Task</th>
                    </tr>
                </thead>
                <tbody>
                    {delegateData.map((data, index) => {
                        return (
                            <tr key={index}>
                                <td>{index + 1}</td>
                                <td>{data.activity}</td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        );
    }

    function DoNotDoTable({ doNotDoData }) {
        return (
            <table className="table text-bg-info" >
                <thead>
                    <tr>
                        <th>SL.</th>
                        <th>Task</th>
                    </tr>
                </thead>
                <tbody>
                    {doNotDoData.map((data, index) => {
                        return (
                            <tr key={index}>
                                <td>{index + 1}</td>
                                <td>{data.activity}</td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        );
    }

    function ActivityTable({ tableData }) {
        return (
            <table className="table" rows={10} paginator>
                <thead>
                    <tr>
                        <th>SL.</th>
                        <th>Activity</th>
                        <th>From Date</th>
                        <th>To Date</th>
                        <th>Remarks</th>
                    </tr>
                </thead>
                <tbody>
                    {tableData.map((data, index) => {
                        return (
                            <tr key={index}>
                                <td>{index + 1}</td>
                                <td>{data.activity}</td>
                                <td>{Moment(data.fromDate).format('d MMM YYYY')}</td>
                                <td>{Moment(data.toDate).format('d MMM YYYY')}</td>
                                <td>{data.remarks}</td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        );
    }
    //#region Modal
    // function ViewModal() {
    //     return (
    //         <>
    //             <Modal show={show} onHide={handleClose}>
    //                 <Modal.Header closeButton>
    //                     <Modal.Title>Employee Task Report</Modal.Title>
    //                 </Modal.Header>
    //                 <Modal.Body>Employee Task List:
    //                     <TaskListTable taskListTableData={taskListTableData} />

    //                     <div className="container">
    //                         <div classsName="row">
    //                             <div className="col">
    //                                 <div className="card mt-2">
    //                                     <div className="card-header d-flex justify-content-between">
    //                                         <h6><i className="bi bi-people-fill"></i> Do First</h6>
    //                                     </div>
    //                                     <div className="card-body">
    //                                         <div className="row g-3 mb-1 align-items-center">
    //                                             <div className="col-md-4">
    //                                                 <DoFirstTable doFirstData={doFirstData}/>
    //                                             </div>
    //                                         </div>
    //                                     </div>
    //                                 </div>
    //                             </div>
    //                             <div className="col">
    //                                 <div className="card mt-2">
    //                                     <div className="card-header d-flex justify-content-between">
    //                                         <h6><i className="bi bi-people-fill"></i> Schedule</h6>
    //                                     </div>
    //                                     <div className="card-body">
    //                                         <div className="row g-3 mb-1 align-items-center">
    //                                             <div className="col-md-4">
    //                                                 {/* <DoFirstTable DoFirstTableData={doFirstData}/> */}
    //                                             </div>
    //                                         </div>
    //                                     </div>
    //                                 </div>
    //                             </div>
    //                         </div>
    //                     </div>

    //                 </Modal.Body>
    //                 <Modal.Footer>
    //                     <Button variant="secondary" onClick={handleClose}>
    //                         Close
    //                     </Button>
    //                 </Modal.Footer>
    //             </Modal>
    //         </>
    //     );
    // }

    //#endregion Modal

    return (<Layout>
        <div className="card mt-2">
            <div className="card-header d-flex justify-content-between">
                <h6><i className="bi bi-people-fill"></i> Task List</h6>
                <div className="col-md-4" style={{ textAlign: 'right' }}>
                    <b>Quarter:</b> {quater.length !== 0 && quater[0].quarterName}/{new Date().getFullYear()}
                </div>
            </div>
            <div className="card-body">
                <div className="row g-3 mb-1 align-items-center">
                    <div className="col-md-12">
                        <Table tableData={tableData} />
                    </div>
                </div>

                {/* <ViewModal /> */}


                {taskListTableData.length !== 0 ? <div>


                    <EmpInfoCard empName={employeeName}
                            department={department}
                            designation={designation}
                             />


                    <div class="col-md-12">
                        <div className="card">
                            <div className="card-header">
                                <h6><i className="bi bi-people-fill"></i> Task List</h6>
                            </div>
                            <div className="card-body">
                                <TaskListTable taskListTableData={taskListTableData} />
                            </div>
                        </div>
                    </div>
                    <br />
                    <h5> Eishenhower Matrix</h5>

                    <div className="row">
                        <div class="col-md-6">
                            <div className="card">
                                <div className="card-header">
                                    <h6><i className="bi bi-people-fill"></i> Do First</h6>
                                </div>
                                <div className="card-body">
                                    <DoFirstTable doFirstData={doFirstData} />
                                </div>
                            </div>
                        </div>
                        <br />
                        <div class="col-md-6">
                            <div className="card">
                                <div className="card-header">
                                    <h6><i className="bi bi-people-fill"></i> Schedule</h6>
                                </div>
                                <div className="card-body">
                                    <ScheduleTable scheduleData={scheduleData} />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div class="col-md-6">
                            <div className="card">
                                <div className="card-header">
                                    <h6><i className="bi bi-people-fill"></i> Delegate</h6>
                                </div>
                                <div className="card-body">
                                    <DelegateTable delegateData={delegateData} />
                                </div>
                            </div>

                        </div>
                        <div class="col-md-6">
                            <div className="card">
                                <div className="card-header">
                                    <h6><i className="bi bi-people-fill"></i> Don't Do</h6>
                                </div>
                                <div className="card-body">
                                    <DoNotDoTable doNotDoData={doNotDoData} />
                                </div>
                            </div>

                        </div>
                    </div>
                    <br />
                    <div class="col-md-12">
                        <div className="card">
                            <div className="card-header">
                                <h6><i className="bi bi-people-fill"></i> Action Plan</h6>
                            </div>
                            <div className="card-body">
                                <ActivityTable tableData={activityList} />
                            </div>
                        </div>
                    </div>

                </div>
                    : <div></div>}


            </div>
        </div>
    </Layout>)
}
export default TaskListReport